<ss-modal
  [modalwidth]="modalWidth"
  [open]="openModal"
  [enableCloseOutside]="enableCloseOutside"
  [showClosingX]="true"
  [dynamicFade]="true"
  (closeClick)="onModalCloseClick($event)"
  [modalwidth]="(isSmallScreen$ | async) ? 90 : 50"
>
  <svg
    closeButton
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-4 h-4 text-white"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
  <div class="p-8 text-ss-brown">
    <h3 class="mb-4 text-center">stay in touch with us</h3>
    <div #errorListing>
      @if (formErrors()?.length) {
        <ss-www-form-error-listing
          class="block mb-4"
          [formErrors]="formErrors()!"
        ></ss-www-form-error-listing>
      }
    </div>
    <form
      class="flex flex-col gap-4"
      (ngSubmit)="onSubmit()"
      [formGroup]="form"
    >
      <ng-container formGroupName="customer">
        <ng-container formGroupName="contact">
          <ss-form-field label="First Name">
            <input ssInput formControlName="firstName" ssBaseInput />
            <ss-form-field-error forError="maxlength">
              First name is too long.
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Last Name">
            <input ssInput formControlName="lastName" ssBaseInput />
            <ss-form-field-error forError="maxlength">
              Last name is too long.
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Primary Phone">
            <input
              ssInput
              type="tel"
              formControlName="phoneNumber"
              mask="(000) 000-0000"
              ssBaseInput
            />
            <ss-form-field-error forError="pattern"
              >Phone number can be only numbers
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength"
              >Phone number is too long
            </ss-form-field-error>
            <ss-form-field-error forError="minlength"
              >Phone number must be at least 10 digits
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Your Email Address">
            <input
              ssInput
              ssForbiddenEmails
              formControlName="emailAddress"
              ssBaseInput
            />
            <ss-form-field-error forError="email">
              Email address is invalid.
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              Email address is too long.
            </ss-form-field-error>
            <ss-form-field-error forError="forbiddenDomain">
              Your email provider is not supported
            </ss-form-field-error>
          </ss-form-field>
        </ng-container>

        <ng-container formGroupName="address">
          @if (countries$ | async; as countries) {
            <ss-form-field label="Country">
              <ss-ui-select [data]="countries">
                <ss-ui-select-trigger
                  ssInput
                  formControlName="country"
                  class="mt-1"
                >
                  Select your country
                </ss-ui-select-trigger>
              </ss-ui-select>
            </ss-form-field>
          }
          <ss-form-field label="Address">
            <input ssInput formControlName="addressLine1" ssBaseInput />
          </ss-form-field>
          <ss-form-field label="Apt/Suite Number">
            <input ssInput formControlName="addressLine2" ssBaseInput />
          </ss-form-field>
          <ss-form-field label="City">
            <input ssInput formControlName="city" ssBaseInput />
          </ss-form-field>
          <ss-form-field label="State">
            <input ssInput formControlName="state" ssBaseInput />
            <ss-form-field-error forError="maxlength"
              >If your country is USA, state should be 2 characters long.
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Zipcode">
            <input ssInput formControlName="zipcode" ssBaseInput />
          </ss-form-field>
        </ng-container>
      </ng-container>

      <div class="mt-4">
        <div class="text-xs leading-4 uppercase tracking-wider">
          what would you like to hear about?
        </div>
        <ng-container formArrayName="marketingInterestIds"></ng-container>
        @for (
          control of form.controls.marketingInterestIds.controls;
          track $index
        ) {
          <ss-checkbox-projection [formControl]="control">
            <div
              class="font-medium text-[14px] leading-[20px] tracking-wide uppercase mt-[2px]"
            >
              {{ (interests$ | async)?.[$index]?.interestName }}
            </div>
          </ss-checkbox-projection>
        }
      </div>

      <hr />
      <div class="mt-5 w-72 mx-auto">
        <ss-button
          class="w-full"
          type="submit"
          buttonColor="principal"
          buttonStyle="filled"
          >Submit</ss-button
        >
      </div>
    </form>
  </div>
</ss-modal>
